/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";

export type AgentCrashFrame = {
  /**
   * Module-relative source file.
   */
  file?: string | undefined;
  /**
   * Fully qualified function name.
   */
  function: string;
  line?: number | undefined;
};

/** @internal */
export type AgentCrashFrame$Outbound = {
  file?: string | undefined;
  function: string;
  line?: number | undefined;
};

/** @internal */
export const AgentCrashFrame$outboundSchema: z.ZodMiniType<
  AgentCrashFrame$Outbound,
  AgentCrashFrame
> = z.object({
  file: z.optional(z.string()),
  function: z.string(),
  line: z.optional(z.int()),
});

export function agentCrashFrameToJSON(
  agentCrashFrame: AgentCrashFrame,
): string {
  return JSON.stringify(AgentCrashFrame$outboundSchema.parse(agentCrashFrame));
}
